module.exports = __webpack_public_path__ + "img/swiper-item2-8.d6354259.png";